import React, {Component} from 'react'
import styled from 'styled-components'
import FullWidthSection from "../components/UI/FullWidthSection";
import CtaButtonSm from "../components/UI/CtaButtonSm";

class JobsPage extends Component {

  render() {
    return (
      <JobsPageContainer>
        <FullWidthSection>
          <div className='Jobs__Content'>
            <div className='headBlurb'>
              <h1>Help us make the next generation of enterprise software.</h1>
              <h3>At AppTree, we're building something new--a platform that empowers everyone to build enterprise
                software.</h3>
              <Divider></Divider>
            </div>
            <div className="whyBlurb">
              <h3>AppTree is looking for someone like you.</h3>
              <p>At AppTree, we know that teams perform best when every member is not only skilled, but brings a
                different perspective to solving problems. We're building a team of diverse, skilled, creative pros that
                are excited about building the next great product in enterprise.</p>
              <p>If you're interested in leading our web development efforts, checkout the jobs below.</p>
            </div>
          </div>
        </FullWidthSection>
        <FullWidthSection bgColor={"#f6f6f6"}>
          <div className='joinBlurb'>
            <h3 className='joinTitle'>Open Positions</h3>
            <div className='posLeft'>
              <h4>Mobile Developer, iOS or Android</h4>
              <p>Join our mobile team developing a world-class enterprise application.</p>
              <h5>Requirements</h5>
              <ul>
                <li>Several years experience coding in Objective C, Swift or Java</li>
                <li>Experience with Android Studio or Xcode</li>
                <li>An interest in databases and some SQL experience</li>
                <li>Track record of teaching, blogging and public speaking is a plus</li>
                <li>Staying current with development, tools and news in the community</li>
              </ul>
            </div>
            <div className='posRight'>
              <h4>Web Developer</h4>
              <p>Our web team uses cutting edge technologies to create customer-facing platforms for browsers and
                mobile. The code you write will be shared between all of our client-side apps. </p>
              <h5>Requirements</h5>
              <ul>
                <li>Several years experience coding in HTML5/JavaScript, Angular & CSS</li>
                <li>Experience with IntelliJ or any other JetBrains IDE</li>
                <li>An interest in databases and some SQL experience</li>
                <li>Desire to learn and code in Dart, Angular Dart, and Flutter</li>
                <li>Some exposure to, or the ability to quickly learn to interact with the iOS and Android SDKs</li>
                <li>Track record of teaching, blogging and public speaking is a plus</li>
                <li>Staying current with development, tools and news in the community</li>
              </ul>
            </div>
          </div>
        </FullWidthSection>
        <FullWidthSection>
          <div className='applyBlurb'>
            <h4>Apply Now</h4>
            <p>If you feel you’re a match, we’d love to hear from you! To make the conversation easier, send your
              resume + github (or links to relevant works of code) to jobs@apptreesoftware.com. Your email will be
              read with extra attention by our CTO.</p>
            <p>If you’d like to join us but don’t meet the requirements of this particular position, please feel free
              to email us at jobs@apptreesoftware.com and tell us how you’d like to help!</p>
            <p>We offer competitive salaries, stock options and the usual perks.</p>
            <a
              className="ctaButton"
              href="mailto:jobs@apptreesoftware.com"
            >
              Send Resume Now →
            </a>
          </div>
        </FullWidthSection>
      </JobsPageContainer>
    )
  }
}

export default JobsPage

const JobsPageContainer = styled.div`
  .Jobs__Content {
    display: grid;
    grid-template-areas: 
      "head"
      "why";
    justify-content:center;
    grid-row-gap: 50px;
    
    
    @media screen and (max-width: 768px) {
      display: block;
    }
    
    .headBlurb {
      grid-area:head;
      margin: auto;
      text-align: center;
      
      
      h1, h3 {
        margin: auto;
        margin-bottom: 25px; 
      }
      h1 {width: 70%}
      h3 {width: 85%}
    }
    .whyBlurb {
      grid-area:why;
      width: 800px;
      margin: auto;
      
      
    @media screen and (max-width: 768px) {
      width: 90%;
    }
      
      h3 {        
        text-align: center;
        margin-bottom: 25px; 
      }
      p {
      margin-bottom: 30px; 
      text-align:center;
      }
    }
  }
  
  .joinBlurb {
      grid-area:join;
      width: 1000px;
      margin: auto;
      display: grid;
      grid-template-areas: "title title" "right left";
      grid-template-columns: 1fr 1fr;
      justify-content:center;
      grid-column-gap: 80px;
      
      
      @media screen and (max-width: 768px) {
        width: 90%;
        display: flex;
        flex-flow: column;
        
        & h4 {
          margin: 30px auto;
          border-bottom: .5px solid black;
        }
        
        & h5 {
          margin: 20px;
        }
      }
    
    
      .joinTitle {
        grid-area:title;
        text-align: center;
      }
      .posLeft {grid-area:left}
      .posRight {grid-area:right}
      .posLeft, .posRight {
        h4 {
          font-size: 2rem; 
          margin-bottom: 15px;
          text-align: center; 
        }
        p {margin: 10px 0;}
        h5 {margin: 10px 0;}
        ul {list-style: circle;}
      }
    }
    
    .applyBlurb{
      grid-area:apply;
      width: 800px;
      margin: auto;
      display: flex;
      flex-direction: column;
      
      
    @media screen and (max-width: 768px) {
      width: 90%;
    }
      
      h4 {        
        text-align: center;
        margin-bottom: 25px; 
      }
      p {
      margin-bottom: 30px; 
      text-align:center;
      }
      span {
        display: inline-block;
      }
    }
    
  .ctaButton {
    background: #43AB60;
    border-radius: 4px;
    padding: 10px 20px;
    border: 1px solid #43AB60;
    margin: auto;
    display: inline-block;
    transition: all 200ms ease;
    font-size: 2rem;
    color: white;
    
    &:hover {
      cursor: pointer;
      background: white !important;
      border: 1px solid #43AB60;
      color: #43AB60;
      }
  }
`

const ButtonContainer = styled.div`

`

const Divider = styled.div`
  border-bottom: .5px solid black;
  width: 60%;
  margin: 50px auto;
`


// WEBPACK FOOTER //
// ./src/pages/jobs.jsx